import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { action as markView } from './action';
import { Component } from './component';

import { ACTION_ERROR_INTER } from '../rating-list/constant';
import { POPUP_LIST_MODULE_NAME } from '../popup-list';

export const Container: React.FC<{
  popupId: string;
  isIcon?: boolean;
  onClose: () => void;
}> = ({ popupId, onClose, isIcon = false }) => {
  const queryClient = useQueryClient();

  const action = useMutation(() => markView({ popupId }), {
    onSuccess: () => {
      queryClient.invalidateQueries([POPUP_LIST_MODULE_NAME]);
    },
  });

  const handleSubmit = () => {
    onClose();
    action.mutate();
  };

  const getErrorMessage = () => {
    const error: ACTION_ERROR_INTER = action.error as ACTION_ERROR_INTER;

    if (error) {
      return error.message;
    }
  };

  return (
    <Component
      errorMessage={getErrorMessage()}
      isLoading={action.isLoading}
      isError={action.isError}
      isIcon={isIcon}
      // disabled={disabled}
      onClick={handleSubmit}
    />
  );
};
